const CI_COMMIT_REF_NAME = "trunk";
const CI_COMMIT_SHORT_SHA = "70967150";
const INTEGRATES_BUCKET_NAME = "views.fluidattacks.com";

export { CI_COMMIT_REF_NAME, CI_COMMIT_SHORT_SHA, INTEGRATES_BUCKET_NAME };
